/**
 * `client.shipping` (#1114): customer rate quotes (public) and the owner label desk (bearer token,
 * orders:manage). The server derives tenant from the token and prices every rate.
 */
export class ShippingClient {
    request;
    constructor(request) {
        this.request = request;
    }
    /** POST /v1/sites/{slug}/shipping/rates (public). */
    quote(slug, input) {
        return this.request("POST", `/v1/sites/${encodeURIComponent(slug)}/shipping/rates`, input);
    }
    getSettings() {
        return this.request("GET", "/v1/shipping/settings", undefined, true);
    }
    putSettings(settings) {
        return this.request("PUT", "/v1/shipping/settings", settings, true);
    }
    /** `state` filters by fulfilment (paid, label_bought, ...); omitted lists paid + label_bought. */
    async listOrdersToShip(state) {
        const q = state ? `?state=${encodeURIComponent(state)}` : "";
        const res = await this.request("GET", `/v1/shipping/orders${q}`, undefined, true);
        return res.orders;
    }
    getShipmentRates(orderId, parcel) {
        return this.request("POST", `${orderPath(orderId)}/shipment/rates`, parcel ? { parcel } : {}, true);
    }
    buyLabel(orderId, shipmentId, rateId) {
        return this.request("POST", `${orderPath(orderId)}/shipment/label`, { shipmentId, rateId }, true);
    }
    voidLabel(orderId) {
        return this.request("POST", `${orderPath(orderId)}/shipment/void`, {}, true);
    }
    markShipped(orderId, trackingNumber) {
        return this.request("POST", `${orderPath(orderId)}/shipment/mark-shipped`, trackingNumber ? { trackingNumber } : {}, true);
    }
    getShipment(orderId) {
        return this.request("GET", `${orderPath(orderId)}/shipment`, undefined, true);
    }
}
function orderPath(orderId) {
    return `/v1/orders/${encodeURIComponent(orderId)}`;
}
//# sourceMappingURL=shipping.js.map